import { ImageResolution } from "../PhotosForm/hooks/useImageResizer";

export interface FormattedPhoto {
  original_filename: string;
  content_type: string;
  resolutions: Array<{
    url: string;
    size: number;
    resolution: ImageResolution;
  }>;
}

export enum PropertyKind {
  SingleFamily = "single_family",
  MultiFamily = "multi_family"
}

interface BlankUnit {
  title: string;
  monthly_rent_amount: number | null;
  home_rent_amount: number | null;
  site_rent_amount: number | null;
  occupied: boolean;
  available_at: string;
  external_id?: string;
}

export interface PropertyFormData {
  name: string;
  kind: PropertyKind | null;
  description?: string;
  external_id?: string;
  owner_name?: string;

  address1: string;
  address2?: string;
  city: string;
  state_or_province: string;
  postal_code: string;
  country?: string;
  lat?: number;
  lng?: number;
  address_name?: string;

  use_property_group_verification_template?: boolean;
  verification_template_id?: string;

  monthly_rent_amount?: number;
  home_rent_amount?: number;
  site_rent_amount?: number;
  available_at?: string;
  occupied?: boolean;
  unit_external_id?: string;
  listing_id?: string;

  sqft?: number;
  beds?: number;
  baths?: number;
  sale_price?: number;
  dimensions?: string;

  amenities: number[];

  cats_allowed: boolean;
  dogs_allowed: boolean;

  logo?: string;
  primary_color?: string;
  palette?: Record<string, string>;
  landlord_name?: string;
  landlord_phone?: string;
  landlord_email?: string;
  media?: FormattedPhoto[];

  units: BlankUnit[];
}

export interface CreateCRMPropertyRequest {
  media_session_key: string;
  name: string;
  kind: PropertyKind | null;
  address: {
    address1: string;
    address2?: string;
    city: string;
    state_or_province: string;
    postal_code: string;
    country?: string;
    lat?: number;
    lng?: number;
    name?: string;
  };
  amenity_ids: number[];
  pet_policy: {
    cats_allowed: boolean;
    dogs_allowed: boolean;
  };
  branding: {
    logo?: string;
    primary_color?: string;
    landlord_name?: string;
    landlord_phone?: string;
    landlord_email?: string;
    palette?: Record<string, string>;
  };
  units?: Array<{
    title?: string;
    monthly_rent_amount?: {
      cents: number;
      currency: string;
    };
    home_rent_amount?: {
      cents: number;
      currency: string;
    };
    site_rent_amount?: {
      cents: number;
      currency: string;
    };
    available_at?: string;
    occupied?: boolean;
    external_id?: string;
    listing_id?: string;
    plan?: {
      sqft?: number;
      baths?: number;
      beds?: number;
    };
    sale_price?: {
      cents: number;
      currency: string;
    };
    dimensions?: string;
  }>;

  owner_name?: string;
  description?: string;
  external_id?: string;
  use_property_group_verification_template?: boolean;
  verification_template_id?: string;
  media?: FormattedPhoto[];
}
